module.exports = __webpack_public_path__ + "static/media/svvgfx.e3ba0d0a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/gfx/svvgfx.svg
// module id = 84
// module chunks = 0